import { Flex, Spinner, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { BseDto, ReceivedBseBidDto, useListReceivedBidsQuery } from "../../../../autogen/bff-api";
import { CreateContractDetail } from "./CreateContractDetail";
import { useNegotiation } from "./NegotiationContext";

export const CreateContracts = ({ sourcingEvent }: { sourcingEvent: BseDto }) => {
  const [winningBids, setWinningBids] = useState<ReceivedBseBidDto[]>();

  const { latestRound } = useNegotiation();

  const {
    data: bidsResponse,
    error,
    isLoading,
  } = useListReceivedBidsQuery({ eventId: sourcingEvent.id, negotiationRound: latestRound?.id });

  useEffect(() => {
    setWinningBids(bidsResponse?.bids.filter((bid) => sourcingEvent.awardedFields?.winningBidIds.includes(bid.id)));
  }, [bidsResponse?.bids, sourcingEvent.awardedFields?.winningBidIds]);

  if (error) return <Text>{t("Something went wrong, could not load bids")}...</Text>;

  if (isLoading) {
    return (
      <Flex width={"full"} justifyContent={"center"} pt="8">
        <Spinner />
      </Flex>
    );
  }

  return (
    <Flex flexDirection={"column"} pt="4">
      <Text fontWeight={"semibold"} fontSize={"lg"}>
        {t("Winning suppliers")}
      </Text>
      {winningBids?.map((bid) => (
        <CreateContractDetail key={bid.id} bid={bid} sourcingEvent={sourcingEvent} />
      ))}
    </Flex>
  );
};
